<template>
	<transition name="fade">
		<div v-show="open" class="modal-popup" :class="{ active: open }">
			<div class="popup-overlay"></div>

			<div class="container">
				<div class="popup popup-may-scroll">
					<div class="popup-container popup-may-scroll">
						<div class="popup-form popup-may-scroll margin-top-30">
							<div class="form-container popup-may-scroll form-text-container no-border no-shadow">
								<div class="form-content popup-may-scroll text-left">
									<p><strong>Ultimo aggiornamento: 15-10-2024</strong></p>
									<p>&nbsp;</p>
									<p><strong>Premessa</strong></p>
									<p>
										Questo sito internet (definito di seguito come Ius Populi o il Sito Web) ed il dominio iuspopuli.it
										sono di proprietà di Ius Populi S.r.l. (definita di seguito anche come il Titolare), e da essa
										gestiti.
									</p>
									<p>
										L'accesso a Ius Populi e l'utilizzo dei servizi messi a disposizione sono disciplinati dal seguente
										Contratto ed implicano la consapevole presa visione ed integrale accettazione, da parte di qualsiasi
										Utente o Avvocato (di seguito definito anche come Professionista) e senza alcun tipo di riserva, dei
										Termini e Condizioni Generali d'uso in esso contenute.
									</p>
									<p>
										Di conseguenza l'Utente o il Professionista è invitato a leggere attentamente i presenti Termini e
										Condizioni Generali d'uso, prima dell'accesso e dell'utilizzo di qualunque servizio del Sito Web
										sotto sua completa responsabilità.
									</p>
									<p>
										Il Titolare si riserva il diritto, a sua sola discrezione, di modificare in qualsiasi momento il
										contenuto dei Termini e Condizioni Generali d'uso di questo contratto, nella sua totalità o in
										parte, senza notifica previa. Suddette modifiche saranno effettive a partire dalla loro
										pubblicazione sul Sito Web.
									</p>
									<p>
										L'utilizzo di Ius Populi successivamente all'applicazione di tali modifiche e alla pubblicazione sul
										Sito Web, implica che l'Utente o il Professionista riconosca ed accetti i Termini e Condizioni
										Generali d'uso di questo Contratto così come modificati. Di conseguenza l'Utente o il Professionista
										è tenuto a leggere attentamente i Termini e Condizioni Generali d'uso in ogni occasione in cui
										procede all'utilizzo del Sito Web, poiché possono esserci delle modifiche.
									</p>
									<p>
										Se l'Utente o il Professionista non accetta i Termini e Condizioni Generali di questo Contratto, che
										sia in seguito a modifica o meno, non può utilizzare i servizi offerti sul Sito Web.
									</p>
									<p>
										Il Titolare si riserva il diritto, a sua sola discrezione, di negare l'accesso a questo Sito Web, in
										qualsiasi momento e senza necessità di preavviso, a quegli Utenti o Professionisti che non
										rispettino i seguenti Termini e Condizioni Generali d'uso ed a cancellarne l'account.
									</p>
									<p>
										Il Titolare si riserva altresì il diritto, a sua sola discrezione, di cambiare o interrompere in
										ogni momento un/i servizio/i sul Sito Web. L'Utente o il Professionista riconosce ed accetta che il
										Titolare non è tenuto a mantenere il Sito Web o un servizio annesso, così come non dà alcuna
										garanzia, espressa o implicita, in relazione al funzionamento del Sito Web (sia per cause
										riconducibili al Titolare che a causa di avvenimenti di forza maggiore sui quali non può influire il
										Titolare).
									</p>
									<p>
										Per ulteriori informazioni contattare via e-mail l'assistenza clienti all'indirizzo
										<a href="mailto:info@iuspopuli.it">info@iuspopuli.it</a>.
									</p>

									<p>&nbsp;</p>
									<p><strong>1. Descrizione del Sito Web e del servizio</strong></p>
									<p>
										<strong>1.1</strong> Ius Populi è una piattaforma web, ideata e sviluppata al fine di connettere, in
										modo semplice ed ovunque, tutti coloro che hanno bisogno di assistenza legale con un network di
										avvocati specializzati.
									</p>
									<p>
										<strong>1.2</strong> Sulla piattaforma l'Utente avrà a disposizione un'area riservata dalla quale
										potrà:
									</p>
									<ul>
										<li>inserire ed inviare le richieste di assistenza legale;</li>
										<li>usufruire di una chat per comunicare con gli studi legali;</li>
										<li>ricevere i preventivi dagli avvocati ed il profilo professionale di chi li ha inviati;</li>
										<li>
											scegliere, in regime di libera concorrenza, a chi conferire l'incarico per l'assistenza legale;
										</li>
										<li>lasciare una recensione sul profilo dell'avvocato scelto.</li>
									</ul>
									<p>L'Avvocato avrà a disposizione una pagina personale nella quale potrà:</p>
									<ul>
										<li>
											creare un profilo personale e inserire informazioni relative alla propria attività professionale;
										</li>
										<li>ricevere le richieste di assistenza legale pervenute dagli utenti;</li>
										<li>usufruire di una chat per comunicare con gli utenti;</li>
										<li>inviare un preventivo o un parere legale agli utenti;</li>
										<li>modificare il proprio profilo;</li>
										<li>usufruire di tutti i servizi che il portale mette a disposizione.</li>
									</ul>

									<p>&nbsp;</p>
									<p><strong>2. Registrazione</strong></p>
									<p>
										<strong>2.1</strong> Per poter utilizzare i servizi del Sito Web è necessario registrarsi alla
										piattaforma, mediante inserimento di credenziali di accesso personali (username e password). A
										completamento della procedura verrà data la possibilità di esprimere il consenso sia ai Termini e
										Condizioni Generali d'uso che alla Politica sulla Privacy e trattamento dati personali, cliccando
										sullo specifico pulsante per l'accettazione. L'iscrizione è gratuita e consente la creazione e
										attribuzione di un account e di un'area riservata, alla quale si accede mediante l'inserimento delle
										credenziali personali (username e password). L'Utente o il Professionista, all'atto della
										registrazione, si impegna a fornire, mantenere e aggiornare dati e informazioni veritiere, accurate,
										aggiornate e complete.
									</p>
									<p>
										<strong>2.2</strong> L'Avvocato, successivamente all'attivazione di un account, deve procedere a
										completare il proprio profilo per poter iniziare a ricevere le richieste degli Utenti.
									</p>
									<p>
										<strong>2.3</strong> L'Avvocato ha a disposizione 30 giorni di tempo per completare il proprio
										profilo dopo l'attivazione del suo account. Decorsi i termini l'account verrà cancellato e
										l'Avvocato che vorrà usufruire dei servizi del Sito dovrà effettuare una nuova registrazione.
									</p>
									<p><strong>2.4</strong> I nostri servizi non possono essere utilizzati dai minori di 18 anni.</p>
									<p>
										<strong>2.5</strong> Se l'Utente utilizza il Sito Web a nome di una entità giuridica, dichiara e
										garantisce di avere l'autorità sufficiente per poter assoggettare tale entità giuridica a questo
										Contratto.
									</p>
									<p>
										<strong>2.6</strong> Per gli Avvocati l'iscrizione alla piattaforma è riservata a coloro che sono in
										possesso dei requisiti di legge per l'esercizio della professione, regolarmente iscritti presso un
										Ordine degli Avvocati e coperti da idonea assicurazione per la responsabilità civile professionale.
									</p>
									<p>
										<strong>2.7</strong> L'Utente o il Professionista si assume la responsabilità di custodire e
										mantenere riservate le proprie credenziali di accesso, ed è ritenuto responsabile di tutte le
										attività compiute utilizzando le stesse credenziali. L'Utente o il Professionista si impegna
										pertanto a porre in essere tutte le misure di sicurezza idonee e tali da garantire che le sue
										credenziali d'accesso non siano divulgate a terzi e a segnalare immediatamente al Titolare del Sito
										Web qualunque utilizzo non autorizzato della username e/o della password o eventuali altre
										violazioni della sicurezza. A seguito della segnalazione si procederà alla disattivazione della
										registrazione e alla cancellazione di tutti gli eventuali contenuti. Resta inteso che in nessun caso
										il Titolare potrà essere ritenuto responsabile in caso di smarrimento, diffusione, furto o utilizzo
										non consentito da parte di terzi, a qualsiasi titolo, delle credenziali di accesso dell'Utente o del
										Professionista.
									</p>
									<p>
										<strong>2.8</strong> L'Utente ed il Professionista si impegnano a non effettuare più di una
										registrazione e a non registrare account con la finalità di abusare delle funzionalità della
										piattaforma.
									</p>
									<p>
										<strong>2.9</strong> Uno studio legale multidisciplinare e composto da più professionisti ha la
										facoltà di registrarsi con più accounts, a condizione che le competenze indicate in ognuno di loro
										siano diverse e quindi non ci siano più accounts per la stessa materia.
									</p>

									<p>&nbsp;</p>
									<p><strong>3. Richieste e preventivi</strong></p>
									<p>
										<strong>3.1</strong> L'Utente, dopo aver effettuato la registrazione, ha la possibilità di inviare
										una richiesta di assistenza legale, indicando il comune d'interesse, la tipologia della
										controversia, la sua parte in causa (attore o convenuto) e fornendo una descrizione del suo
										problema. Nel suo stesso interesse, l'Utente è tenuto formulare richieste chiare e dettagliate. Ius
										Populi provvede ad inoltrare automaticamente la richiesta agli studi legali con competenze
										specifiche nella materia richiesta ed in ordine di distanza dal comune specificato dall'Utente.
										Tutti gli avvocati informati della richiesta di assistenza legale possono accedere alla propria area
										riservata, leggere la richiesta dell'Utente e, qualora siano disponibili ad accettare l'incarico,
										inviare un preventivo utilizzando l’apposita form. Ricevuti nella sua area riservata i preventivi ed
										i profili professionali degli Avvocati che hanno dato riscontro alla sua richiesta, l'Utente può
										scegliere se e a quale Avvocato conferire l'incarico di assistenza legale. Le richieste sono attive
										per 10 giorni dall'invio e si chiudono al raggiungimento di un massimo di cinque preventivi ricevuti
										o per decorrenza dei termini.
									</p>
									<p>
										<strong>3.2</strong> Durante l’inserimento di una richiesta, all’utente viene chiesto il consenso ad
										essere contattato direttamente dagli studi legali ai quali verrà inviata la sua richiesta. In caso
										affermativo gli studi legali interessati hanno la possibilità di acquisire i contatti dell’utente
										all’atto di formulare il preventivo e secondo le modalità del servizio. In caso l’utente non dia il
										consenso, i suoi dati personali e le informazioni di contatto rimarranno riservati e saranno
										comunicati solo allo studio che avrà scelto per farsi assistere. All'Utente che ha inviato richiesta
										di assistenza legale, saranno visibili solo le informazioni generali degli studi che hanno inviato
										un preventivo, mentre riceverà i dettagli personali e di contatto solo dello studio che avrà scelto
										per farsi assistere.
									</p>
									<p>
										<strong>3.2.1</strong> Durante l’inserimento di una richiesta l’utente ha la facoltà di dare il
										consenso ad essere contattato dagli studi legali ai quali verrà inviata la richiesta stessa. In caso
										venga dato il consenso, gli studi legali hanno la facoltà di entrare direttamente in contatto con
										l’utente, seguendo le modalità e i dettagli di contatto che l’utente ha fornito.
									</p>
									<p>
										<strong>3.3</strong> Agli utenti è richiesto di leggere attentamente, prima di procedere alla scelta
										per il conferimento di incarico, i preventivi ricevuti dai singoli avvocati e le specifiche
										condizioni di erogazione dei servizi professionali offerti.
									</p>
									<p>
										<strong>3.4</strong> L’invio di un preventivo da parte degli studi legali implica un automatismo
										circa la determinazione del compenso per le proprie prestazioni professionali. Gli avvocati quindi,
										quando scelti da un utente per il tramite della piattaforma, sono tenuti a mantenere, come uniche ed
										invariate, le stesse condizioni comunicate in fase di preventivazione.
									</p>
									<p>
										<strong>3.5</strong> Resta inteso che in nessun caso il Titolare potrà essere ritenuto responsabile
										con riferimento alla qualità, caratteristiche e disponibilità dei servizi professionali forniti
										dagli Avvocati.
									</p>
									<p>
										<strong>3.6</strong> Tutte le richieste e i preventivi sono inseriti direttamente e rispettivamente
										dagli Utenti e dagli Avvocati e poiché il Titolare del Sito Web non ha alcun obbligo di controllo
										sulle informazioni inserite, invitiamo ad utilizzare i nostri servizi con prudenza e buonsenso. Di
										conseguenza l'Utente o il Professionista riconosce ed accetta che il Titolare non è responsabile dei
										contenuti delle richieste e delle offerte stesse.
									</p>
									<p>
										<strong>3.7</strong> Il Titolare si riserva il diritto, ma non il dovere, di pre-moderare le
										richieste di assistenza legale inviate dagli utenti e di non inoltrare agli studi legali le
										richieste quando queste non rispettano le regole editoriali o la Policy del servizio.
									</p>
									<p>
										<strong>3.8</strong> Un Utente ha la facoltà di eliminare la propria richiesta in qualunque momento.
									</p>
									<p>
										<strong>3.9</strong> Utenti ed Avvocati hanno a disposizione una chat in cui è possibile inviare
										messaggi, cancellare o modificare messaggi già inviati. Al fine di limitare un uso improprio di
										questo strumento, il titolare si riserva il diritto, ma non il dovere, di pre-moderare i messaggi e
										non inoltrarli se non in linea con la Policy del Sito.
									</p>
									<p>
										<strong>3.10</strong> Il Professionista espressamente accetta di ricevere dei feedback dagli utenti
										in relazione alle sue prestazioni professionali.
									</p>
									<p>
										<strong>3.11</strong> Al fine di garantire agli utenti un servizio di qualità, se decorsi 5 giorni
										dal ricevimento di una richiesta uno studio legale non apre la stessa, la richiesta si chiuderà per
										lo studio legale che l’ha ricevuta e sarà automaticamente inoltrata ad altro studio legale per il
										restante periodo di apertura.
									</p>

									<p>&nbsp;</p>
									<p><strong>4. Responsabilità e diffusione dei contenuti, dati e/o informazioni</strong></p>
									<p>
										<strong>4.1</strong> Ogni informazione o contenuto che l'Utente o il Professionista pubblichi su Ius
										Populi deve essere legale, veritiero e non suscettibile di vulnerare i diritti di terzi né la
										normativa vigente. A questi effetti l'Utente o il Professionista garantisce l'autenticità di tutte
										le informazioni ed i contenuti pubblicati nel Sito Web. Gli unici diritti concessi a Ius Populi in
										relazione ai contenuti forniti dagli Utenti o dai Professionisti sono quelli necessari al
										funzionamento ed al mantenimento dei servizi offerti dal Sito Web.
									</p>
									<p>
										<strong>4.2</strong> L'Utente o il Professionista riconosce ed accetta che il Titolare non è tenuto
										a verificare e pertanto non garantisce un controllo in merito alla qualità, sicurezza, liceità delle
										richieste effettuate dagli utenti e dei preventivi redatti dagli avvocati. Non può inoltre
										verificare la veridicità e l'accuratezza delle informazioni fornite dagli utenti registrati o delle
										attività svolte dai professionisti. Tuttavia il Titolare si riserva la facoltà, ma non il dovere, di
										controllare periodicamente e monitorare attivamente tutti i contenuti del Sito Web, al fine di
										assicurare i principi di qualità così come il rispetto delle norme qui indicate.
									</p>
									<p>
										<strong>4.3</strong> In ogni caso Il Titolare si riserva il diritto di decidere, a sua esclusiva
										discrezione, se un contenuto sia appropriato e sia idoneo secondo questo Contratto. Allo stesso modo
										il Titolare si riserva la potestà di rimuovere, a sua propria unica discrezione e senza necessità di
										notifica, i contenuti illegali, così come quei contenuti che non si considerano appropriati rispetto
										alle caratteristiche e alle finalità del Sito Web o che possano vulnerare i diritti di terzi.
									</p>
									<p>
										<strong>4.4</strong> L'Utente o il Professionista che inserisca un contenuto che infranga la legge
										vigente assumerà la responsabilità esclusiva dei pregiudizi e delle conseguenze derivate dalla
										stessa, esimendo il Titolare da ogni responsabilità.
									</p>
									<p>
										<strong>4.5</strong> Il Titolare si riserva il diritto di rivelare i dati dell'autore di un
										messaggio in suo possesso in caso di richiesta da parte delle autorità competenti.
									</p>
									<p>
										<strong>4.6</strong> Chiunque, utilizzando il Sito Web, nota alcun tipo di contenuto illegale,
										illecito, sconveniente o ritenuto in ogni modo offensivo o inappropriato è invitato a segnalarlo
										tempestivamente al Titolare, che si rende disponibile alla cancellazione immediata ove ravvisi la
										fondatezza della segnalazione.
									</p>
									<p>
										<strong>4.7</strong> Durante l’inserimento di una nuova richiesta non è consentito l'invio di
										documentazione originale. Successivamente, e su specifica richiesta di uno o più studi legali, è
										possibile caricare eventuali documenti utilizzando la chat nell’area personale. L'utente si assume
										la piena responsabilità dei contenuti e in nessun caso il Titolare ne potrà essere ritenuto
										responsabile.
									</p>

									<p>&nbsp;</p>
									<p><strong>5. Obblighi degli Utenti e degli Avvocati</strong></p>
									<p>
										<strong>5.1</strong> L'Utente e il Professionista sono tenuti a servirsi della piattaforma o di ogni
										suo altro contenuto solo per gli scopi d'uso previsti e si impegnano a fare un uso diligente del
										Sito Web e dei servizi accessibili dallo stesso, nel rispetto totale della legge, del buon costume,
										dei presenti Termini e Condizioni Generali d'uso.
									</p>
									<p>
										<strong>5.2</strong> L'Utente e il Professionista sono consapevoli e accettano volontariamente che
										l'uso dei servizi offerti dal Sito Web avviene, in ogni caso, sotto la loro unica ed esclusiva
										responsabilità.
									</p>
									<p>
										<strong>5.3</strong> L'Utente e il Professionista garantiscono la veridicità dei loro dati personali
										comunicati all'atto della prima registrazione e si assumono ogni responsabilità, in ordine al
										materiale immesso e pubblicato sul Sito Web.
									</p>
									<p>
										<strong>5.4</strong> L'Utente conferisce espresso incarico al Titolare di inviare per suo conto la
										propria richiesta di assistenza legale ad uno o più avvocati e, al fine di porre il Titolare nella
										condizione di erogare il servizio, l'Utente si obbliga a fornire, sia al momento della richiesta che
										anche successivamente, informazioni e dati veritieri, esaurienti, completi e tali da non indurre
										terzi in errore.
									</p>
									<p>
										<strong>5.5</strong> L'Utente si impegna a non formulare richieste di assistenza legale con il fine
										di monitorare le risposte o verificare l'attività dei Professionisti che rispondono. E' fatto
										divieto di utilizzare in qualsiasi modo questo Sito Web per attività di analisi di mercato, della
										concorrenza o anche solo per verificare l'identità dei Professionisti iscritti. Abusi in tal senso
										saranno da Ius Populi S.r.l. perseguiti a norma di Legge.
									</p>
									<p>
										<strong>5.6</strong> Ius Populi per poter fornire i suoi servizi necessita di comunicare, via
										e-mail, con gli Utenti e i Professionisti. Questi, dunque, accettano di ricevere tutti quei messaggi
										di posta elettronica necessari per assicurare il normale funzionamento dei servizi offerti,
										all'indirizzo e-mail indicato all'atto della registrazione.
									</p>
									<p>
										<strong>5.7</strong> L'Utente si impegna espressamente a non inviare messaggi il cui contenuto possa
										essere considerato diffamatorio, ingiurioso, osceno, razzista, sessista, blasfemo, pornografico e
										contrario comunque al buon costume, in violazione delle norme in materia di Tutela della Privacy e
										della riservatezza, né per divulgare materiale protetto da diritto d'autore senza il consenso
										dell'avente diritto, o comunque illecito, nel rispetto delle vigenti norme di legge.
									</p>
									<p>
										<strong>5.8</strong> L'Utente è invitato a verificare sempre quello che invia e ad assicurarsi che
										quanto inviato sia conforme ai presenti Termini e Condizioni Generali d'uso.
									</p>
									<p>
										<strong>5.9</strong> L'Utente o il Professionista deve inoltre astenersi da fare un uso in qualunque
										modo illecito del Sito Web e da tutte le azioni che potrebbero manipolare, sovraccaricare e/o
										interferire con le operazioni della piattaforma o con le infrastrutture tecniche di supporto e con
										le sue funzioni/mezzi d'accesso.
									</p>
									<p>
										<strong>5.10</strong> L'Utente o il Professionista è altresì tenuto a fare tutto quanto in proprio
										potere per salvaguardare i propri sistemi informatici dall'accesso di terzi non autorizzati, anche
										mediante virus informatici.
									</p>
									<p>
										<strong>5.11</strong> Gli Avvocati devono impegnarsi ad assistere gli Utenti nel miglior modo
										possibile, in maniera da non compromettere la qualità del servizio fornito dal Sito Web. In
										particolare, l'Avvocato dovrà garantire di avere i titoli, le risorse, le conoscenze,
										l'organizzazione e le capacità organizzative, idonee per rispondere alla richiesta di assistenza
										legale dell'Utente e &ndash; nel caso di studi legali &ndash; assicurare la capacità e la perizia di
										ogni singolo Professionista di cui l'Utente dovesse avvalersi.
									</p>
									<p>
										<strong>5.12</strong> L'Utente si impegna a non utilizzare i servizi resi dal Sito Web per qualsiasi
										scopo illegale, intimidire o molestare un altro Utente, un Professionista o soggetti terzi,
										astenersi da azioni moleste anche se non espressamente previste come lesive.
									</p>
									<p>
										<strong>5.13</strong> L'Utente ed il Professionista si impegnano a mantenere indenne Ius Populi
										S.r.l. da qualsiasi conseguenza pregiudizievole derivante dalla violazione dei suesposti obblighi e
										da qualsivoglia pretesa o azione a loro rivolta da terzi.
									</p>
									<p>
										<strong>5.14</strong> Nel caso che l'Utente rilevi malfunzionamenti della piattaforma è tenuto a
										darne immediata comunicazione al Titolare del Sito Web, affinchè questi possa provvedere
										tempestivamente ad ovviare all'eventuale malfunzionamento.
									</p>

									<p>&nbsp;</p>
									<p><strong>6. Restrizioni</strong></p>
									<p>
										<strong>6.1</strong> è espressamente vietato qualsiasi uso differente rispetto alle finalità di
										questo Sito Web e in qualunque modalità non autorizzata da questo contratto o che violi la legge, i
										regolamenti o il codice in una giurisdizione applicabile.
									</p>
									<p>
										<strong>6.2</strong> è vietato inviare contenuti inappropriati, che possano violare i diritti di
										altri, considerarsi dannosi, minatori, illegali, diffamatori, ingiuriosi, istigatori, osceni,
										indecenti, fraudolenti, espressione di odio o di natura razzista, etnica o di altro tipo, che vadano
										contro la legge e che ostacolino l'utilizzo del Sito Web da parte di terzi o che possano esporre Ius
										Populi S.r.l. o terzi a qualsiasi danno o responsabilità di qualsiasi tipo.
									</p>
									<p>
										<strong>6.3</strong> Non è permesso inviare un contenuto, che sia protetto da diritti d'autore o
										altri diritti di proprietà intellettuale a meno che l'Utente o il Professionista non possieda o
										controlli questi diritti o che ne abbia ricevuto tutte le autorizzazioni necessarie.
									</p>
									<p>
										<strong>6.4</strong> Non è consentito in alcun caso inviare informazioni private di terzi, incluso,
										tra le altre cose, immagini, indirizzi, numero di telefono, indirizzo di posta elettronica, etc.
										L'Utente può pubblicare solamente contenuti di cui è proprietario o del quale possieda permessi o
										licenza da parte del proprietario.
									</p>
									<p>
										<strong>6.5</strong> è vietato utilizzare qualsiasi materiale e informazione contenuti in questo
										Sito Web con fini illeciti ed espressamente proibiti nei presenti Termini e Condizioni Generali
										d'uso o che si ritenga che siano contrari ai diritti e agli interessi del Sito Web, degli utenti o
										professionisti registrati e/o di terzi.
									</p>
									<p>
										<strong>6.6</strong> Chiunque sarà responsabile e dovrà rispondere di fronte agli stessi, in caso di
										contravvenire o non rispettare questi obblighi e/o che, in qualsiasi modo (inclusa l'introduzione o
										diffusione di virus informatici) possa danneggiare, rendere inaccessibile, sovraccaricare,
										deteriorare o impedire il normale uso dei materiali e delle informazioni contenuti nel Sito Web, i
										sistemi di informazione o i documenti, archivi ed ogni tipo di contenuti immagazzinati in qualsiasi
										apparecchiatura informatica del Titolare degli Utenti o Professionisti registrati e/o di terzi.
									</p>
									<p><strong>6.7</strong> è inoltre proibito:</p>
									<ul>
										<li>
											riprodurre e diffondere pubblicamente contenuti del Sito Web o degli Utenti e Professionisti
											registrati alla piattaforma senza previa autorizzazione dei legittimi titolari;
										</li>
										<li>
											usare notizie ingannevoli, scorrette (per esempio nomi o indirizzi e-mail fallaci o scorretti),
											per e durante l'utilizzo del Sito Web, ivi compreso e senza limitazione, rispetto l'origine o la
											fonte di ogni contenuto o di ogni altro materiale che l'Utente o il Professionista carichi o ogni
											dato personale che identifichi il suo account;
										</li>
										<li>
											l'uso di software o altri processi comunque nominati, in grado di analizzare ed indicizzare
											qualunque parte del Sito Web o dei suoi contenuti;
										</li>
										<li>
											porre in essere quelle azioni atte a sovraccaricare la struttura del Sito Web, in particolare al
											fine di pregiudicarne in qualsiasi modo la funzionalità;
										</li>
										<li>
											aggirare i sistemi informatici usati dal Sito Web per proteggere il contenuto accessibile tramite
											di essa;
										</li>
										<li>
											cercare di ottenere un accesso non autorizzato a sistemi materiali o informatici (hardware e
											software) o risorse associate al Sito Web, né di ottenere servizi o informazioni intenzionalmente
											non resi disponibili dal Titolare.
										</li>
										<li>
											cercare di ottenere un accesso non autorizzato ad un account di un'altra persona fisica o entità
											giuridica, né di disturbare l'utilizzo di un'altra persona fisica o giuridica sul Sito Web;
										</li>
										<li>appropriarsi illecitamente dell'account in uso presso altro Utente o Professionista;</li>
									</ul>
									<p>
										<strong>6.8</strong> è vietato utilizzare la chat per scambiare messaggi al cui interno siano
										contenute informazioni personali e/o dettagli di contatto.
									</p>

									<p>&nbsp;</p>
									<p><strong>7. Cancellazione account e risoluzione del contratto</strong></p>
									<p>
										<strong>7.1</strong> L'Utente o il Professionista registrato può risolvere in ogni momento questo
										contratto, aprendo una sessione del suo account sul Sito Web e utilizzare l'apposita procedura di
										cancellazione dell'account. In nessun caso l'esercizio del diritto di terminare il contratto da
										parte dell'Utente o del Professionista costituirà titolo per richiedere risarcimenti di qualunque
										genere, tipo e per qualsiasi motivo.
									</p>
									<p>
										<strong>7.2</strong> Il Titolare, in caso di violazione dei presenti Termini e Condizioni Generali
										d’uso o di lunghi periodi di inattività, si riserva il diritto di sospendere temporaneamente o
										chiudere l'account dell'Utente o del Professionista in ogni momento e senza preavviso. In nessun
										caso la chiusura o la sospensione dell'account da parte del Titolare può costituire titolo per
										qualsivoglia richiesta di indennizzo o pretesa risarcitoria da parte dell'Utente o del
										Professionista. È fatto comunque salvo ogni diritto del Titolare di richiedere il pagamento
										dell’eventuale maggior danno subito.
									</p>
									<p>
										<strong>7.3</strong> Il Titolare avrà inoltre la facoltà di sospendere temporaneamente o cancellare
										l'account di un Avvocato, in caso di scarsa soddisfazione, da parte degli Utenti, dei servizi
										forniti. La soddisfazione degli Utenti verrà misurata in base alle recensioni pubblicate nella
										pagina personale dell'Avvocato e/o ai reclami ricevuti dal Titolare nei confronti dell'Avvocato che
										non dovesse fornire i suoi servizi professionali in conformità con quanto accordato nel preventivo.
									</p>
									<p>
										<strong>7.4</strong> In seguito alla chiusura di un account il Titolare provvederà immediatamente
										alla cancellazione delle credenziali personali e all'eliminazione di tutti i relativi contenuti
										dell'area riservata.
									</p>
									<p>
										<strong>7.5</strong> L'Utente o il Professionista più volte cancellato che continui a registrarsi
										col solo scopo di turbare il regolare svolgimento del servizio verrà segnalato alle competenti
										autorità.
									</p>

									<p>&nbsp;</p>
									<p><strong>8. Corrispettivi e pagamenti</strong></p>
									<p>
										<strong>8.1 </strong>La registrazione alla piattaforma, l'attivazione di un account personale e la
										disponibilità di un'area riservata, non sono attività vincolanti e sono gratuite.
									</p>
									<p>
										<strong>8.2</strong> L'utente può inviare gratuitamente una richiesta di assistenza legale nelle
										modalità descritte nel Sito.
									</p>
									<p>
										<strong>8.3</strong> L'Avvocato può consultare gratuitamente tutte le richieste che riceve e inviare
										un preventivo, attraverso l'utilizzo di crediti prepagati, solo a quelle a cui è interessato. Il
										numero dei crediti utilizzato per inviare un preventivo ad una singola richiesta è fisso (1). Se
										durante l’inserimento di una richiesta l’utente ha dato il consenso ad essere contattato
										direttamente, gli studi legali che ricevono la richiesta hanno la possibilità di acquisire i
										dettagli di contatto nelle modalità descritte nel form per l’invio del preventivo.
									</p>
									<p>
										<strong>8.3.1</strong> Un singolo credito ha un valore economico pari ad Euro 6 comprensivo di
										I.V.A.
									</p>
									<p>
										Non è prevista la vendita di un singolo credito, i crediti possono essere acquistati solo nelle
										modalità previste nel Sito e attraverso &ldquo;pacchetti&rdquo; predisposti. La Società avrà la
										facoltà di variare i corrispettivi, anche temporaneamente, per l'acquisto dei crediti. Tali
										variazioni saranno valide a decorrere dalla data di pubblicazione sul Sito. La Società avrà altresì
										la facoltà di attribuire gratuitamente crediti agli Avvocati. I crediti acquistati hanno una
										validità di 24 (ventiquattro) mesi a partire dalla data di acquisto.
									</p>
									<p>
										<strong>8.3.2 </strong>I crediti possono essere rimborsati entro 45 giorni di calendario
										dall'acquisto, a condizione che nei primi 30 giorni dalla data dell'acquisto stesso non sia stato
										possibile utilizzare alcun credito poiché, a causa di fattori di mercato, non sono state ricevute
										richieste. Non sono previsti rimborsi parziali, se è stato acquistato un pacchetto crediti, il
										diritto al rimborso è previsto solo per pacchetti integri in cui nessun credito è stato utilizzato.
										In nessun caso l'Avvocato avrà diritto al rimborso di eventuali crediti attribuiti gratuitamente o
										nel caso di mancato utilizzo dei crediti entro il termine di validità. La richiesta di cancellazione
										del proprio account, determinerà la perdita dei crediti acquistati, senza alcun diritto al rimborso
										dei crediti non ancora utilizzati.
									</p>
									<p>
										<strong>8.3.3</strong> L'Avvocato ha la possibilità di controllare lo stato dei crediti all'interno
										della sua pagina personale, dove verrà contabilizzato ogni movimento. Se l'Avvocato ha utilizzato
										tutti i crediti, continuerà a ricevere e visualizzare le nuove richieste, ma dovrà acquistarne altri
										per poter rispondere.
									</p>
									<p>
										<strong>8.4</strong> I pagamenti sono effettuati in euro (EUR) mediante uno dei metodi di pagamento
										accettati dal Sito. Il Sito utilizza strumenti terzi per l'elaborazione dei pagamenti e non entra in
										alcun modo in contatto con i dati di pagamento &ndash; come quelli relativi alla carta di credito
										&ndash; forniti. I servizi di elaborazione dei pagamenti attraverso l'uso di Paypal, sono soggetti
										alle condizioni d'uso del servizio della stessa.
									</p>

									<p>&nbsp;</p>
									<p><strong>9. Ranking</strong></p>
									<p>
										<strong>9.1</strong> Il sistema è predisposto per formare automaticamente un ranking con tutti gli
										Avvocati iscritti alla piattaforma, in base al punteggio raggiunto da ognuno di loro e suddiviso per
										aree di competenza.
									</p>
									<p>
										<strong>9.2</strong> Quando un Avvocato riceve una richiesta a cui non è interessato, è data la
										facoltà di rispondere comunque all'Utente, esprimendo un sintetico parere legale e senza utilizzare
										alcun credito. Ogni risposta di questo genere contribuirà a dare un punteggio all'Avvocato che l'ha
										inviata.
									</p>
									<p>
										<strong>9.3</strong> Quando una nuova richiesta viene inviata a più studi legali, i tre di loro con
										il punteggio più alto al momento stesso dell'invio avranno il diritto di riceverla, consultarla e
										poter rispondere per 24 ore, prima che la richiesta sia inoltrata a tutti gli altri Avvocati.
									</p>

									<p>&nbsp;</p>
									<p><strong>10. Autonomia delle parti</strong></p>
									<p>
										<strong>10.1</strong> L'attività svolta dal Titolare consiste esclusivamente nell'offrire e
										mantenere una piattaforma online attraverso la quale si incontrano le richieste degli Utenti e le
										risposte dei Professionisti. Non è né un mediatore né un intermediario, si limita a mettere in
										diretto contatto gli Utenti con gli Avvocati, senza intervenire in alcun modo nei rapporti tra loro.
									</p>
									<p>
										<strong>10.2</strong> Il Titolare è autonomo e indipendente dagli avvocati registrati alla
										piattaforma e che si avvalgono dei servizi offerti dal Sito Web. L'utilizzo dei servizi da parte
										degli Avvocati non determina l'insorgere di alcun rapporto, quali a titolo esemplificativo e non
										esaustivo, collaborazione, agenzia, associazione, intermediazione o lavoro subordinato.
									</p>
									<p>
										<strong>10.3</strong> Il Titolare non stabilisce nessun tipo di rapporto di esclusiva con gli
										avvocati registrati alla piattaforma.
									</p>
									<p>
										<strong>10.4</strong> Il Titolare non ricopre alcun ruolo nella conclusione dell'accordo di
										prestazione dei servizi che si svolge esclusivamente tra l'Utente e l'Avvocato, i quali agiscono in
										piena autonomia ed indipendenza.
									</p>

									<p>&nbsp;</p>
									<p><strong>11. Limitazioni di responsabilità</strong></p>
									<p>
										<strong>11.1</strong> In aggiunta alle esclusioni di responsabilità già indicate in precedenza,
										l'Utente o il Professionista comprende ed accetta che il Titolare non garantisce la disponibilità,
										continuità, né l'infallibilità del funzionamento del Sito Web e di conseguenza libera Ius Populi
										S.r.l. da qualsiasi responsabilità per i danni ed i pregiudizi di ogni tipo dovuti alla mancanza di
										disponibilità o di continuità del funzionamento del Sito Web e dei servizi abilitati nello stesso.
									</p>
									<p>
										<strong>11.2</strong> Il Titolare non potrà essere ritenuto responsabile per danni o perdite
										derivanti da interruzioni o malfunzionamenti del Sito Web dovuti ad eventi di forza maggiore o,
										comunque, ad eventi imprevisti ed imprevedibili e, comunque, indipendenti dalla volontà ed estranei
										alla sfera di controllo del Titolare, quali, a titolo esemplificativo e non esaustivo, guasti o
										interruzioni alle linee telefoniche o elettriche, alla rete internet e/o comunque ad altri strumenti
										di trasmissione, indisponibilità di siti web, scioperi, eventi naturali, virus ed attacchi
										informatici, interruzioni nell'erogazione di prodotti, servizi o applicazioni di terze parti ed
										errato o inidoneo utilizzo del Sito Web da parte dell'Utente, del Professionista o di terzi.
									</p>
									<p>
										<strong>11.3</strong> L'uso del Sito Web e delle funzionalità accessibili attraverso lo stesso, è
										effettuato dall'Utente o dal Professionista sotto la propria responsabilità. Pertanto il Titolare
										non sarà responsabile per eventuali perdite che non siano conseguenza diretta della violazione delle
										presenti Condizioni Generali d'uso da parte dello stesso.
									</p>
									<p>
										<strong>11.4</strong> L'Utente o il Professionista accetta e riconosce che il Titolare non sia
										ritenuto in alcun modo responsabile delle perdite economiche, dei danni diretti e indiretti, di
										danni eventualmente subiti dall'Utente, dal Professionista o da terzi, in conseguenza al suo
										utilizzo del Sito Web o dei propri servizi.
									</p>
									<p>
										<strong>11.5</strong> L'Utente o il Professionista accetta e riconosce che il Titolare non sia in
										alcun modo responsabile per i danni e i pregiudizi di ogni natura dovuti alla mancanza si esattezza,
										esaustività, attualità, così come errori od omissioni dei quali possano soffrire le informazioni e i
										servizi contenuti in questo Sito Web, né che il Titolare assume alcun dovere o impegno di vigilare e
										verificare i contenuti e le informazioni, né che lo stesso può garantire che i servizi ottenuti
										tramite l'utilizzo del Sito Web siano all'altezza delle aspettative dell'Utente o del
										Professionista.
									</p>
									<p>
										<strong>11.6</strong> L'Utente o il Professionista comprende ed accetta che il Titolare non si
										occupa di controllare la veridicità, completezza e accuratezza delle informazioni fornite
										dall'Utente o dal Professionista, né ha l'obbligo di controllare l'uso che gli stessi fanno del
										servizio e, di conseguenza, non garantisce che l'Utente o il Professionista utilizzi lo stesso in
										conformità con quanto stabilito nei presenti Termini e Condizioni Generali d'uso, né che ne facciano
										un uso diligente e/o prudente.
									</p>
									<p>
										<strong>11.7</strong> L'Utente o il Professionista comprende ed accetta che il Titolare non si
										occupa di controllare la capacità e professionalità degli avvocati registrati, né verifica il
										contenuto ed il merito delle prestazioni rese dagli avvocati agli utenti attraverso l'uso del Sito
										Web, limitandosi a mettere a disposizione di utenti e avvocati la piattaforma e gestirne il
										funzionamento.
									</p>
									<p>
										<strong>11.8</strong> L'Avvocato che espleta l'incarico professionale è esclusivamente e
										direttamente responsabile nei confronti dell'Utente per l'opera prestata. Ne consegue che è esclusa
										qualsivoglia responsabilità del Titolare per l'assistenza legale resa dall'Avvocato all'Utente.
									</p>
									<p>
										<strong>11.9</strong> Il Titolare non è responsabile di quello che si svolge tra l'Utente ed il
										Professionista una volta che sono stati messi in contatto tra loro.
									</p>
									<p>
										<strong>11.10</strong> L'Utente o il Professionista riconosce ed accetta che il Titolare non può
										essere ritenuto responsabile dei contenuti di altri siti web, collegati tramite link ipertestuale, e
										della loro accessibilità.
									</p>
									<p>
										<strong>11.11</strong> Il Titolare non sarà responsabile delle recensioni rilasciate dagli utenti
										sul profilo degli avvocati, anche se utilizzerà i mezzi a sua disposizione per moderare nella misura
										delle sue possibilità le opinioni espresse dagli utenti, con l'obiettivo di evitare la violazione
										dei diritti di terzi.
									</p>

									<p>&nbsp;</p>
									<p><strong>12. Manleva</strong></p>
									<p>
										<strong>12.1</strong> Qualsiasi controversia emergente tra l'Utente ed il Professionista appartiene
										alla esclusiva responsabilità dei soggetti direttamente coinvolti.
									</p>
									<p>
										<strong>12.2</strong> Accettando i presenti Termini e Condizioni Generali d'uso, ci si impegna a
										mantenere indenne Ius Populi S.r.l. (nonché gli amministratori e i dipendenti), da qualsiasi obbligo
										o responsabilità che dovesse sorgere a fronte di danni provocati a terzi, in relazione ai contenuti
										caricati online, alla violazione della legge o dei presenti Termini e Condizioni Generali d'uso.
									</p>
									<p>
										<strong>12.3</strong> Chiunque si registri alla piattaforma, avendo pienamente compreso i Termini e
										le Condizioni Generali d'uso riportate nel presente documento circa il trattamento dei dati
										personali e la tutela della privacy in genere, si impegna a non muovere pretese o richiedere
										risarcimenti di alcun genere a Ius Populi S.r.l. in ordine a pretese violazioni della normativa
										sulla Privacy vigente e si impegna, altresì, a non adottare comportamenti che possano ledere la
										Privacy di altri utenti o professionisti registrati o di soggetti terzi, per i dati personali di
										questi che siano giunti a sua conoscenza tramite l'utilizzo di questo Sito Web.
									</p>

									<p>&nbsp;</p>
									<p><strong>13. Diritti di proprietà intellettuale e industriale</strong></p>
									<p>
										<strong>13.1</strong> Tutti i contenuti disponibili nel Sito Web sono soggetti ai diritti di
										proprietà industriale e intellettuale di Ius Populi S.r.l. e/o di terzi, titolari degli stessi, che
										hanno autorizzato a suo tempo l'inserimento nel Sito Web. Pertanto, è fatto espresso divieto a
										chiunque di copiare, scaricare, modificare, pubblicare, trasmettere, vendere, elaborare,
										trasferire/cedere a terzi o creare lavori derivati in qualsiasi modo dai contenuti, anche di terzi,
										disponibili sul Sito Web, né consentire che terzi lo facciano tramite l'Utente o il suo dispositivo,
										anche a sua insaputa.
									</p>
									<p>
										<strong>13.2</strong> La legittimità dei diritti di proprietà intellettuale o industriale
										corrispondenti ai contenuti apportati dall'Utente o dal Professionista è di esclusiva responsabilità
										degli stessi.
									</p>

									<p>&nbsp;</p>
									<p><strong>14. Dati personali degli utenti e dei professionisti</strong></p>
									<p>
										<strong>14.1</strong> Le Informazioni personali sono tutti i dati che si comunicano al Titolare o a
										terzi all'atto della registrazione, della presentazione di richieste di assistenza legale e/o dei
										preventivi stessi.
									</p>
									<p>
										<strong>14.2</strong> La società trattiene tutti i dati personali forniti dagli utenti o dai
										professionisti nel pieno rispetto delle disposizioni contenute nel d.lgs. 30 giugno 2003, n. 196,
										secondo le modalità e per le finalità indicate nell'informativa fornita all'Utente o al
										Professionista ex art. 13 del Codice.
									</p>
									<p>
										<strong>14.3</strong> Con la presa visione dell'informativa di cui all'art. 13 del D.lgs. 196/2003 e
										con la adesione al presente Contratto, l'Utente o il Professionista manifesta il proprio espresso
										consenso al trattamento e alla comunicazione dei dati che lo riguardano, per le finalità e con le
										modalità descritte nella predetta informativa.
									</p>

									<p>&nbsp;</p>
									<p><strong>15. Garanzia</strong></p>
									<p>
										<strong>15.1</strong> Il Sito Web offre i propri servizi "nelle condizioni in cui si trovano", senza
										alcuna garanzia ulteriore, espressa o implicita.
									</p>
									<p>
										<strong>15.2</strong> Il Titolare non è responsabile di eventuali errori od omissioni nelle
										informazioni contenute in questo Sito Web o delle conseguenze derivanti dall'uso di tali
										informazioni. Tutte le informazioni contenute in questo Sito Web sono fornite "per quello che sono",
										senza garanzia sulla completezza, sull'accuratezza, sull'aggiornamento, o sulle conseguenze
										derivanti dall'uso di tali informazioni. In nessun caso il Titolare o i suoi collaboratori saranno
										ritenuti responsabili per eventuali danni di qualsiasi tipo verso terzi, inclusi i danni
										conseguenti, che derivano dall'utilizzo o dall'incapacità di utilizzo di questo Sito Web, o da ogni
										altra informazione ivi fornita, o decisione presa o azione intrapresa in relazione a tali
										informazioni. Eventuali decisioni che dovessero essere prese dai fruitori del Sito Web, sulla base
										dei dati e delle informazioni qui fornite, sono assunte in piena autonomia decisionale.
									</p>
									<p>
										<strong>15.3</strong> Il Titolare potrà effettuare modifiche ai contenuti del Sito Web in qualunque
										momento senza preavviso, pur non assumendosi alcun impegno di aggiornamento.
									</p>

									<p>&nbsp;</p>
									<p><strong>16. Modifiche ai presenti Termini e Condizioni Generali d'uso</strong></p>
									<p>
										<strong>16.1</strong> Il Titolare si riserva il diritto di modificare, in tutto o in parte ed in
										qualunque momento, i presenti Termini e Condizioni Generali d'uso. Tali modifiche saranno vincolanti
										non appena pubblicate sul Sito Web in sostituzione della precedente versione. L'Utente o il
										Professionista che continui ad utilizzare il Sito Web successivamente alla pubblicazione delle
										modifiche, accetta senza riserve i nuovi Termini e Condizioni Generali d'uso, fatta salva la loro
										possibilità di cancellarsi in qualsiasi momento dalla piattaforma.
									</p>

									<p>&nbsp;</p>
									<p><strong>17. Inefficacia e nullità parziale</strong></p>
									<p>
										<strong>17.1</strong> Qualora una qualsiasi clausola del presente Contratto dovesse risultare nulla,
										non valida o inefficace, la suddetta clausola sarà eliminata, mentre tutte le restanti clausole non
										saranno da ciò condizionate e rimarranno pienamente in vigore.
									</p>

									<p>&nbsp;</p>
									<p><strong>18. Legge applicabile e Foro</strong></p>
									<p>
										<strong>18.1</strong> I presenti Termini e Condizioni Generali d'uso e tutte le controversie in
										merito ad esecuzione, interpretazione e validità sono soggette alla legge Italiana.
									</p>
									<p>
										<strong>18.2</strong> Le parti convengono quale Foro competente in via esclusiva per ogni
										controversia concernente i presenti Termini e Condizioni Generali d'uso il Foro di Milano.
									</p>
									<p>
										<strong>18.3</strong> Per quanto non espressamente previsto o regolato dai presenti Termini e
										Condizioni Generali d'uso dovrà farsi esclusivo riferimento alle norme previste dall'ordinamento
										legislativo italiano.
									</p>

									<p>&nbsp;</p>
									<p><strong>19. Comunicazioni</strong></p>
									<p>
										<strong>19.1</strong> Salvo quanto diversamente previsto, tutte le comunicazioni relative al Sito
										Web devono essere inviate utilizzando le informazioni di contatto indicate nell'apposita sezione.
									</p>
								</div>
							</div>
						</div>
					</div>

					<div class="close-btn" @click="preCloseModal">
						<i class="fa fa-close"></i>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import ModalHelper from '@/mixins/ModalHelper'

export default {
	name: 'TermsAndConditionsModal',
	mixins: [ModalHelper],
	mounted() {
		// Listen for open modal event
		this.$root.$on('open-terms-and-conditions-modal', () => {
			this.open = !this.open
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-terms-and-conditions-modal')
	},
	methods: {
		preCloseModal() {
			this.closeModal()
		},
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/utils/modals/misc/TermsAndConditionsModal.vue